module.exports = __webpack_public_path__ + "img/icon-thumbs-down-full.ee481492.svg";